/**
 * Phone number normalization.
 *
 * @param  {string} value
 * @return {string}
 */
export default function (value) {
  return `${value}`.replace(/\D/g, '');
}
